/*
 * @Author: cgt
 * @Date: 2024-03-01 11:56:46
 * @LastEditors: cgt
 * @LastEditTime: 2024-03-01 12:01:02
 * @Description: 
 */
/*
|--------------------------------------------------------------------------
|
| 对应 package.json/appGroupName
|
|--------------------------------------------------------------------------
*/

export const LIB_NAME = 'aiop-base';
